import { REACT_APP_API_TEGRA } from "../settings";

const urlApiTegra = REACT_APP_API_TEGRA;

function _handleErros(response: any) {
  if (!response.ok) {
    if (response.status === 401) {
      return (window.location.href = "/login");
    }
    if (response.status === 400) {
      return response;
    }
    if (response.status === 404) {
      return response;
    }
    if (response.status === 409) {
      return response;
    }
    if (response.status === 413) {
      return response;
    }
    if (response.status === 500) {
      return response;
    }
    console.error(`Opa! temos um Erro:${response.status}`);
    return response;
  }
  return response;
}

const get = (url: string, token: string) => {
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
  })
    .then((res) => _handleErros(res))
    .then((res) => res.json())
    .catch((err) => console.error(err));
};

const getWithoutTokenAndWithoutHeaders = (url: string) => {
  return fetch(url)
    .then((res) => _handleErros(res))
    .then((res) => res.json())
    .catch((err) => console.error(err));
};

const getWithoutToken = (url: string) => {
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
  })
    .then((res) => _handleErros(res))
    .then((res) => res.json())
    .catch((err) => console.error(err));
};

const getDownload = (url: string, token: string) => {
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
  })
    .then((res) => _handleErros(res))
    .then((res) => res)
    .catch((err) => console.error(err));
};

const getByID = (url: string, token: string) => {
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
  })
    .then((res) => _handleErros(res))
    .then((res) => res.json())
    .catch((err) => console.error(err));
};

const post = (url: string, body: any, token: string) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => _handleErros(res))
    .then((res) => res)
    .catch((err) => console.error(err));
};

const postFormData = (url: string, body: any, token: string) => {
  const formData = new FormData();

  for (const name in body) {
    formData.append(name, body[name]);
  }

  return fetch(url, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
    body: formData,
  })
    .then((res) => _handleErros(res))
    .then((res) => res)
    .catch((err) => console.error(err));
};

const postNoBody = (url: string, token: string) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
  })
    .then((res) => _handleErros(res))
    .then((res) => res)
    .catch((err) => console.error(err));
};

const postlogin = (url: string, body: any) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    body: JSON.stringify(body),
  })
    .then((res) => _handleErros(res))
    .then((res) => res)
    .catch((err) => console.error(err));
};

const put = (url: string, body: any, token: string) => {
  return fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
    body: JSON.stringify(body),
  })
    .then((res) => _handleErros(res))
    .then((res) => res)
    .catch((err) => console.error(err));
};

const putFile = (url: string, body: any, token: string) => {
  const formData = new FormData();

  for (const name in body) {
    formData.append(name, body[name]);
  }

  return fetch(url, {
    method: "PUT",
    headers: {
      //   "Content-Type": "multipart/form-data",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
    body: formData,
  })
    .then((res) => _handleErros(res))
    .then((res) => res)
    .catch((err) => console.error(err));
};

const del = (url: string, token: string) => {
  return fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Authorization: token,
    },
  })
    .then((res) => _handleErros(res))
    .then((res) => res)
    .catch((err) => console.error(err));
};

export {
  urlApiTegra,
  get,
  getWithoutToken,
  getWithoutTokenAndWithoutHeaders,
  post,
  postFormData,
  put,
  putFile,
  postlogin,
  del,
  getDownload,
  getByID,
  postNoBody,
};
